import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * `cn` — combina clsx + tailwind-merge.
 * Permite concatenar clases condicionales (clsx) resolviendo conflictos
 * entre utilidades Tailwind (tailwind-merge) — p.ej. `px-2 px-4` → `px-4`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export type { ClassValue };
